import React from "react"
import { FormGroup, Label, Input, FormFeedback } from "reactstrap"

const TextInput = ({
    label,
    name,
    type = "text",
    placeholder,
    validation,
    helperText,
    readOnly = false,
    required = true,
    maxLength,
    className = "",
    inputClassName = "",
    handleChange,
    emptyText, // Custom empty text, defaults to "[label] not found"
    pattern,
    ...rest
}) => {
    const showHelperText = !readOnly && (helperText || maxLength)
    const hasError = validation.touched[name] && validation.errors[name]
    const currentLength = validation.values[name]?.length || 0
    const remainingChars = maxLength ? maxLength - currentLength : null
    const hasValue =
        validation.values[name] && validation.values[name].toString().trim() !== ""




    // Check if the field is optional by looking at the validation schema
    const isRequired = required && !readOnly

    // Determine helper text to show
    const getHelperText = () => {
        if (maxLength) {
            const charText = `${remainingChars} ${remainingChars === 1 ? "character" : "characters"
                } remaining`
            return helperText ? `${helperText} (${charText})` : charText
        }
        return helperText
    }

    // Get display value for readonly mode
    const getDisplayValue = () => {
        if (readOnly && !hasValue) {
            const fieldName = label ? label.replace("*", "").trim() : name
            return emptyText || `${fieldName} not found`
        }
        return validation.values[name] || ""
    }


    return (
        <FormGroup
            className={`mb-3 ${showHelperText ? "info-text-input-container" : ""
                } ${className}`}
        >
            {label && (
                <Label htmlFor={name}>
                    {label}
                    {isRequired ? "*" : ""}
                </Label>
            )}

            <Input
                id={name}
                name={name}
                type={type}
                placeholder={readOnly ? "" : placeholder}
                value={getDisplayValue()}
                onChange={handleChange || validation.handleChange}
                onBlur={validation.handleBlur}
                readOnly={readOnly}
                invalid={hasError ? true : false}
                maxLength={maxLength}
                pattern={pattern}
                className={`form-control ${readOnly ? "input-as-text" : ""
                    } ${inputClassName} ${readOnly && !hasValue ? "text-danger" : ""}`}
                {...rest}
                spellCheck={true}
            />

            {hasError ? (
                <FormFeedback type="invalid">{validation.errors[name]}</FormFeedback>
            ) : null}

            {showHelperText && (
                <span
                    className={`text-muted text-end ${readOnly ? "d-none" : "d-inline-block"
                        } ${hasError ? "w-50" : "w-100"}`}
                >
                    {getHelperText()}
                </span>
            )}
        </FormGroup>
    )
}

export default TextInput
